import React from "react";
import { Link } from "react-router-dom";
import { FilePlus2, TrendingUp, ShieldAlert, FileText, Percent, FolderArchive, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Kpi } from "@/components/dashboard/Kpi";
import { RiskDistributionChart } from "@/components/dashboard/RiskDistributionChart";
import { ActivityFeed } from "@/components/dashboard/ActivityFeed";
import { CategoryGrid } from "@/components/dashboard/CategoryGrid";
import { RiskTrendsChart } from "@/components/dashboard/RiskTrendsChart";
import { SubscriptionCard } from "@/components/dashboard/SubscriptionCard";
import { EvidenceBanner } from "@/components/dashboard/EvidenceBanner";

export const ProDashboard = ({ stats, user, isPm = false, portfolio = null }) => (
  <div className="space-y-6">
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h2 className="font-display text-xl font-semibold">
          {isPm ? "Property Manager" : "Pro Host"} dashboard
        </h2>
        <p className="text-sm text-muted-foreground">Welcome back{user?.business_name ? `, ${user.business_name}` : ""}. Your professional risk management overview.</p>
      </div>
      <div className="flex gap-2">
        <Link to="/app/evidence"><Button variant="outline" className="gap-2" data-testid="dashboard-evidence-centre-btn"><FolderArchive className="h-4 w-4" /> Evidence Centre</Button></Link>
        <Link to="/app/new"><Button className="gap-2" data-testid="dashboard-new-assessment-button"><FilePlus2 className="h-4 w-4" /> New assessment</Button></Link>
      </div>
    </div>

    <EvidenceBanner />

    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <Kpi label="Total assessments" value={stats.total_all_time} sub={`${stats.total_this_month} this month`} icon={FilePlus2} accent="hsl(var(--primary))" testid="kpi-total-all" />
      <Kpi label="High-risk rate" value={`${stats.high_risk_pct}%`} sub={`${stats.high} high-risk results`} icon={ShieldAlert} accent="#c93838" testid="kpi-high-risk-pct" />
      <Kpi label="Evidence reports generated" value={stats.reports_generated} sub={`${stats.saved_count} saved`} icon={FileText} accent="hsl(var(--primary))" testid="kpi-reports-generated" />
      <Kpi label="Average risk score" value={stats.average_score} sub="across all assessments" icon={TrendingUp} accent="hsl(var(--primary))" testid="kpi-average-score" />
    </div>

    <CategoryGrid categories={stats.categories} />

    <div className="grid gap-6 lg:grid-cols-3">
      <div className="lg:col-span-2"><RiskTrendsChart trend={stats.trend} /></div>
      <RiskDistributionChart stats={stats} />
    </div>

    <div className="grid gap-6 lg:grid-cols-3">
      <div className="lg:col-span-2"><ActivityFeed activity={stats.activity} /></div>
      <SubscriptionCard subscription={stats.subscription} />
    </div>

    {isPm && portfolio}
  </div>
);
